import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrashAlt,
  faCopy,
  faClipboard
} from '@fortawesome/free-regular-svg-icons';
import { nanoid } from 'nanoid';
import Tooltip from './Tooltip.js';

export default function ActionOptions({ curList, curUTM, updateUTMList }) {
  const [label, setLabel] = useState('Copy to Clipboard');

  const deleteCurUTM = (id, oldState) => {
    if (curList.length === 1) return;

    const newState = [...oldState];
    const index = newState.findIndex((i) => i.id === id);
    newState.splice(index, 1);
    updateUTMList(newState);
  };

  const duplicateCurUTM = (id, oldState) => {
    let newState = [...oldState];
    const index = newState.findIndex((i) => i.id === id);
    let duplicateUTM = newState[index];
    duplicateUTM = { ...duplicateUTM, id: nanoid() };
    newState = [...newState, duplicateUTM];

    updateUTMList(newState);
  };

  return (
    <div className="grid__col-lg-1 u--padding-0">
      <div className="utm__form__input u--padding-0 u--display-flex u--flex u--flex-direction-row u--justify-content-space-evenly u--align-content-center">
        <Tooltip content="Delete UTM" tipClass="utm">
          <button
            className="btn  btn--outline utm__action-icon"
            onClick={() => deleteCurUTM(curUTM.id, curList)}
          >
            <FontAwesomeIcon icon={faTrashAlt} />
          </button>
        </Tooltip>
        <Tooltip content="Duplicate UTM" tipClass="utm">
          <button
            className="btn  btn--outline utm__action-icon"
            onClick={() => duplicateCurUTM(curUTM.id, curList)}
          >
            <FontAwesomeIcon icon={faCopy} />
          </button>
        </Tooltip>
        <Tooltip content={label} tipClass="utm">
          <button className="btn  btn--outline utm__action-icon">
            <FontAwesomeIcon
              icon={faClipboard}
              onClick={() => {
                navigator.clipboard.writeText(curUTM.utm);
                setLabel('Copied');
                setTimeout(() => setLabel('Copy to Clipboard'), 2000);
              }}
            />
          </button>
        </Tooltip>
      </div>
    </div>
  );
}
